import { queryClient } from "services/api";
import { Customer } from "types";

export const setCustomerQueryData = (customer: Customer) =>
  queryClient.setQueryData(["customer", customer.id], customer);
